// extracted by mini-css-extract-plugin
export var section = "rowBlocksSec-module--section--1sd54";
export var inner = "rowBlocksSec-module--inner--23vgx";